export default __webpack_public_path__ + "static/header-about-4edf706af264e82b0865225a24cb39c5.jpg";